import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const CoachingIcon = props => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    fill="none"
    {...props}>
    <Path
      fill="#8697AB"
      fillRule="evenodd"
      d="M5.392 9.97c0-3.201 2.57-5.797 5.739-5.797s5.738 2.596 5.738 5.797c0 3.202-2.57 5.798-5.738 5.798-3.17 0-5.739-2.596-5.739-5.798Zm5.739-3.75c-2.051 0-3.713 1.679-3.713 3.75 0 2.072 1.662 3.752 3.713 3.752 2.05 0 3.713-1.68 3.713-3.752 0-2.071-1.663-3.75-3.713-3.75ZM5.73 19.86c-1.678 0-3.038 1.374-3.038 3.069v1.62a.05.05 0 0 0 .042.05 51.589 51.589 0 0 0 16.794 0 .05.05 0 0 0 .042-.05v-1.62c0-1.695-1.36-3.07-3.038-3.07h-.46a.336.336 0 0 0-.105.017l-1.17.386a11.7 11.7 0 0 1-7.334 0l-1.168-.386a.336.336 0 0 0-.105-.016h-.46ZM.667 22.929c0-2.825 2.266-5.115 5.063-5.115h.46c.25 0 .497.04.733.117l1.17.386a9.695 9.695 0 0 0 6.076 0l1.169-.386c.237-.078.484-.117.733-.117h.46c2.797 0 5.064 2.29 5.064 5.115v1.62a2.09 2.09 0 0 1-1.74 2.07 53.597 53.597 0 0 1-17.448 0 2.09 2.09 0 0 1-1.74-2.07v-1.62Z"
      clipRule="evenodd"
    />
    <Path
      fill="#8697AB"
      fillRule="evenodd"
      d="M12.457 2.758A5.704 5.704 0 0 1 16.869.667c3.17 0 5.739 2.595 5.739 5.797 0 2.8-1.966 5.137-4.58 5.679a7.37 7.37 0 0 0 .335-2.202v-.042a3.753 3.753 0 0 0 2.22-3.435c0-2.072-1.663-3.751-3.714-3.751-.866 0-1.663.3-2.295.802a7.134 7.134 0 0 0-2.117-.757Zm13.136 20.354a53.67 53.67 0 0 1-2.633.368v-.99c0-.361-.03-.715-.09-1.06.8-.093 1.6-.206 2.396-.337a.05.05 0 0 0 .042-.05v-1.62c0-1.696-1.36-3.07-3.038-3.07h-.46a.335.335 0 0 0-.105.017l-1.169.385c-.268.089-.539.168-.812.236a6.693 6.693 0 0 0-3.337-.883h-.598c-.323 0-.645.05-.952.148l-.146.046a7.26 7.26 0 0 0 1.39-1.035 9.694 9.694 0 0 0 3.827-.457l1.168-.385c.237-.078.485-.118.734-.118h.46c2.797 0 5.063 2.29 5.063 5.115v1.621a2.09 2.09 0 0 1-1.74 2.07Z"
      clipRule="evenodd"
    />
  </Svg>
);

export default CoachingIcon;
